import { useState } from "react";

/**
 * @description - The purpose of this hook is to trigger re-render when all provided refs has been set, that'll help in scenarios where we need to render component only when refs have been set
 * @param {any[]} refs
 * @return {{isRefsInit: boolean, setRefs: (function(*): function(*): void)}}
 */
const useRefsInit = (refs) => {
  const [isRefsInit, setRefsInit] = useState(false);

  const setRefs = (ref) => (providedRef) => {
    ref.current = providedRef;
    if (!isRefsInit && refs.every((ref) => Boolean(ref.current))) {
      setRefsInit(true);
    }
  }

  return {
    isRefsInit,
    setRefs,
  }
};

export default useRefsInit;